import dynamic from 'next/dynamic'

import { mq, spacing, styled, Text } from '@thg-commerce/enterprise-theme'
import { Button } from '@thg-commerce/gravity-elements'

const Bag = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/Bag'),
  { loading: () => <div style={{ width: 24, height: 24 }} /> },
)
const Video = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/Video'),
  { loading: () => <div style={{ width: 24, height: 24 }} /> },
)

export const BagIcon = styled(Bag)<{
  heartButton?: boolean
  margin?: number
}>`
  display: block;
  stroke: currentColor;
  stroke-width: 0.5px;
  height: 24px;
`
export const VideoIcon = styled(Video)<{
  heartButton?: boolean
  margin?: number
}>`
  display: block;
  stroke: currentColor;
  stroke-width: 0.5px;
  height: 24px;
`

export const IconographyWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid ${(props) => props.theme.colors.palette.greys.light};
`

export const IconographyContainer = styled.div<{ childCount: number }>`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 90%;
  max-width: 370px;
  min-width: 315px;
  padding: 0 ${(props) => (props.childCount < 3 ? spacing(2) : '0')};
  height: 75px;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    display: none;
  }
`

export const ButtonWrapper = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: ${spacing(0.5)};

  ${Text('small', 'alternate')}
  text-transform: uppercase;
  text-decoration: none;
  color: ${(props) => props.theme.colors.palette.greys.darker};
  min-width: 95px;

  &:hover,
  &:active {
    color: ${(props) => props.theme.colors.palette.greys.darker};
    ${Text('small', 'alternate')}
  }
`
export const WishWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: ${spacing(0.5)};
  
  ${Text('small', 'alternate')}
  color: ${(props) => props.theme.colors.palette.greys.darker};
  padding: 3px;
  cursor: pointer;
  min-width: 95px;

  > * {
    height: 24px;
  }

  > span {
    text-transform: uppercase;
  }

  button {
    padding: 0;
    margin: 0;
    height: 24px;
    border: none;

    :focus {
    border: none;
  }
`
